import { render, staticRenderFns } from "./channel-list-header.vue?vue&type=template&id=cf01383c&"
import script from "./channel-list-header.vue?vue&type=script&lang=ts&"
export * from "./channel-list-header.vue?vue&type=script&lang=ts&"
import style0 from "./channel-list-header.vue?vue&type=style&index=0&id=cf01383c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports